/**
 * DEF-38 (2026-09-29): Shopify storefront forms on the LOCAL theme-dev preview.
 *
 * Shopify protects /contact posts (contact and newsletter forms) with hCaptcha,
 * whose site key is bound to the store's own domain. On the local `shopify theme
 * dev` host (127.0.0.1:9292) the check cannot pass: a real browser lands on
 * Shopify's "Your connection needs to be verified before you can proceed" page
 * and nothing is sent. Verified 2026-09-29: the identical form submitted on
 * store.qualgear.com (theme preview) reached ?contact_posted=true and showed the
 * success message — the form and the store are fine; the local host is not a
 * place a Shopify form can be sent from.
 *
 * On local hosts ONLY, a valid submit to /contact is stopped before the captcha
 * runs, and the form explains why and links to the same page on the store's own
 * domain with this theme previewed. Customers never see this: the script exits
 * immediately on any other hostname.
 *
 * Registered after `load` so qg-form-guard.js's capture listeners (registered
 * earlier) validate first — an invalid form is still stopped by the guard and
 * shows its inline errors, so validation stays testable locally.
 */
(function () {
  var host = window.location.hostname;
  var isLocal = host === '127.0.0.1' || host === 'localhost' || host === '[::1]' || /\.localhost$/.test(host);
  if (!isLocal) return;

  function storePreviewUrl() {
    var shop = window.Shopify && window.Shopify.shop;
    var theme = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
    if (!shop || !theme) return null;
    return 'https://' + shop + window.location.pathname + '?preview_theme_id=' + theme;
  }

  function showNote(form) {
    var note = form.querySelector('.qg-local-preview-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'qg-local-preview-note';
      note.setAttribute('role', 'status');
      var submit = form.querySelector('[type="submit"]');
      (submit && submit.parentNode ? submit.parentNode : form).appendChild(note);
    }
    var url = storePreviewUrl();
    note.textContent = 'Not sent: this local preview cannot send forms, because Shopify’s spam check only runs on the store’s own domain. ';
    if (url) {
      var a = document.createElement('a');
      a.href = url;
      a.textContent = 'Open this page on the store preview';
      note.appendChild(a);
      note.appendChild(document.createTextNode(' to test the full submission.'));
    }
  }

  function register() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!/\/contact(?:[#?]|$)/.test(action)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      // Give the form back (qg-form-guard.js put it in its pending state).
      form.dispatchEvent(new CustomEvent('qg:form-reset'));
      showNote(form);
    }, true);
  }

  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
})();
